export default __webpack_public_path__ + "static/media/locker.58b1839f.svg";